
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/park/[slug]",
      function () {
        return require("private-next-pages/park/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/park/[slug]"])
      });
    }
  